/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export const DEFAULT_SEARCH_TAG = 'default';
export function docVersionSearchTag(pluginId, versionName) {
    return `docs-${pluginId}-${versionName}`;
}
